export enum SettingsFlowchartRulesDataEventObjectsEnum {
  CREATE_BRANCHING_RULE = 'create_branching_rule',
  SAVE_BRANCHING_RULE = 'save_branching_rule',
  DELETE_BRANCHING_RULE = 'delete_branching_rule',
  CONVERT_TO_BRANCHING_RULE = 'convert_to_branching_rule',

  SAVE_BRANCHING_RULE_PANEL = 'save_branching_rule_panel',

  START_CREATE_RULE = 'start_create_rule',
}
